exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-UserInfo__start-button,\n.cs-UserInfo__start-button:visited {\n  color: #fff;\n  text-decoration: underline;\n}\n.cs-UserInfo__start-button:hover {\n  color: #fff;\n  text-decoration: underline;\n  text-shadow: 0 0 20px #ffa;\n}\n.cs-UserInfo__stopButton {\n  background: none;\n  border: none;\n  text-decoration: underline;\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/UserInfo/UserInfo.less
// module id = 833
// module chunks = 0